import "../styles/Community.css";
import { Helmet } from "react-helmet";

function Community() {
  return (
    <>
      <Helmet>
        <title>Community Involvement | Jax Utilities Management</title>
        <meta
          name="description"
          content="Discover how Jax Utilties Management contributes to the Jacksonville community through various initiatives and partnerships."
        />
        <meta
          name="keywords"
          content="community involvement, Jacksonville, construction community, corporate responsibility"
        />
        <meta
          property="og:title"
          content="Community Involvement | Jax Utilities Management"
        />
        <meta
          property="og:description"
          content="See how Jaxum contributes to building a stronger Jacksonville community through various initiatives and partnerships."
        />
        <meta
          property="og:image"
          content="https://www.jaxum.com/assets/community/dream-team1.png"
        />
        <meta property="og:url" content="https://www.jaxum.com/community" />
        <link rel="canonical" href="https://www.jaxum.com/community" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Community Involvement | Jax Utilities Management"
        />
        <meta
          name="twitter:description"
          content="See how Jaxum contributes to building a stronger Jacksonville community."
        />
        <meta
          name="twitter:image"
          content="https://www.jaxum.com/assets/community/dream-team1.png"
        />
      </Helmet>
      <div className="community-container">
        <div className="community-content">
          <div className="community-section">
            <div className="community-header">
              <h2 className="community-title">Dream Team</h2>
              <p className="community-quote">
                Honored to be a part of the Dream Team, supporting their
                inspiring mission. #DreamTeam #JUM
              </p>
            </div>

            <div className="community-image">
              <img
                src="../assets/community/dream-team1.png"
                alt="Dream Team 1"
              />
            </div>

            <div className="community-image">
              <img
                src="../assets/community/dream-team3.png"
                alt="Dream Team 3"
              />
            </div>
            <div className="community-image">
              <img
                src="../assets/community/dream-team31.png"
                alt="Dream Team 4"
              />
            </div>
            <div className="community-footer">
              <p className="community-quote">
                It's an honor to work alongside the Dream Team, supporting their
                dedication to excellence and inspiring dreams! #JUMDreamTeam
                #InspiringDreams
              </p>
            </div>

            <div className="community-image">
              <img
                src="../assets/community/dream-team2.png"
                alt="Dream Team 2"
              />
            </div>
          </div>

          <div className="community-section">
            <div className="community-header">
              <h2 className="community-title">JUM for Jessica</h2>
              <p className="community-quote">
                As a key player in the world of golf, Jessica embodies the
                passion, drive, and talent we stand behind. We can't wait to see
                her shine on the course and continue to inspire with her
                incredible skill and dedication. Let's go Jessica – this is just
                the beginning! 🙌🏻
              </p>
            </div>

            {/* Placeholder for images */}
            <div className="community-image">
              <img src="..\assets\community\jessica1.png" alt="jessica1.png" />
            </div>
            <div className="community-image">
              <img src="..\assets\community\jessica2.png" alt="jessica2.png" />
            </div>
            <div className="community-image">
              <img src="..\assets\community\jessica3.png" alt="jessica3.png" />
            </div>

            <div className="community-footer">
              <p className="community-quote">
                Together, we're setting new standards for excellence. Proud to
                support Jessica in her journey! #JUMForJessica #GolfInspiration
              </p>
            </div>
          </div>

          <div className="community-section">
            <div className="community-image single">
              <img
                src="..\assets\community\Monique.jpg"
                alt="Monique Edd Foundation"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Community;
